module.exports = {"450109100":"蒲庙镇","450109101":"那楼镇","450109102":"新江镇","450109103":"百济镇","450109202":"中和乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450109.json
// module id = 2074
// module chunks = 0